import React from 'react';
import './Projects.css';
import holden from './holden.png';
import jamieson from './rees.jpg';
import cullen from './ferg.png';

const coaches = [
  {
    name: 'Holden Rogers',
    role: 'Skills & Forward Development',
    photo: holden,
    bio: [
      'Junior experience in both GOJHL and OJHL',
      'Team MVP Milton Menace (OJHL)',
      'OJHL All star 2022',
      'Usports experience with TMU Bold and Brock Badgers',
      'OUA West Second Team All-Star',
      'Top 20 in Usports scoring',
      'Brock Press Male Athlete of the Month (October)',
      'Team MVP and top scorer for Brock Badgers',
      'Currently Assistant Coach u12 AAA STA Admirals',
    ],
    accolades: ['OJHL All-Star', 'League Goal Leader', 'Team MVP', 'Brock University'],
  },
  {
    name: 'Jamieson Rees',
    role: 'Elite Forward Coaching',
    photo: jamieson,
    bio: [
      'OHL Cup Champion',
      'Elite two-way player, high compete level and hockey IQ',
      '1st round pick to OHL (Sarnia Sting)',
      'OHL standout with Sarnia Sting (Over 100 career points)',
      '2nd round NHL draft pick (Carolina Hurricanes)',
      'Alternate Captain final year with Sarnia',
      'Represented Canada internationally at u17 Hlinka Gretzky Cup (Gold Medal)',
      'Over 300 games played in the American Hockey League',
      'Over 100 AHL points recorded',
      'Calder Cup Champion with the Chicago Wolves',
      'Currently playing with Straubing Tigers of the DEL (Germany)',
    ],
    accolades: ['NHL 2nd Round Pick', 'Calder Cup Champion', 'AHL Veteran', 'Belleville Senators'],
  },
  {
    name: 'Cullen Ferguson',
    role: 'Defense & Systems',
    photo: cullen,
    bio: [
      'Junior Experience in GOJHL, NAHL, and BCHL',
      'NAHL Defensemen of the month (February)',
      'NCAA Division 1 with Union College (ECAC)',
      'Union College Rookie of the year',
      '4x ECAC Hockey All Academic Team',
      'Deans List',
      'ECAC Defender of the week (February Junior Year)',
      'Over 140 NCAA games',
      'Captain of Union College (Senior Year)',
      'ECHL experience with Fort Wayne Komets and Bloomington Bison',
      'Currently with the Greensboro Gargoyles of the ECHL',
    ],
    accolades: ['NCAA Division I', 'ECAC All-Academic ×3', 'Freshman of the Year', 'Union College'],
  },
];

const Projects = () => (
  <div className="coaches-page">
    <div className="coaches-page__hero">
      <h1>Meet the Coaches</h1>
      <p>At RFR Pro, our coaches don't just talk the talk, they've lived it at the highest levels of the game.</p>
    </div>

    <div className="coaches-list">
      {coaches.map(({ name, role, photo, bio, accolades }, i) => (
        <div className={`coach-card${i % 2 === 1 ? ' coach-card--reverse' : ''}`} key={name}>
          <div className="coach-card__photo">
            <img src={photo} alt={name} />
          </div>
          <div className="coach-card__body">
            <span className="coach-card__role">{role}</span>
            <h2 className="coach-card__name">{name}</h2>
            <ul className="coach-card__bio">
              {bio.map((line, idx) => <li key={idx}>{line}</li>)}
            </ul>
            <ul className="coach-card__accolades">
              {accolades.map(a => <li key={a}>{a}</li>)}
            </ul>
          </div>
        </div>
      ))}
    </div>

    <div className="coaches-cta">
      <p>Want to train with our coaches? <a href="/contact">Reach out today.</a></p>
    </div>
  </div>
);

export default Projects;